import Multiselect from './multiselect.vue';

export default Multiselect;


// WEBPACK FOOTER //
// ./src/components/inputs/multiselect/index.js